@if (iShowError) {
  <div class="error-block">
    <p>{{message}}</p>
  </div>
}
